import { useEffect, useState } from "react";
import { criarKPI, atualizarKPI, getKPI } from "../../../services/kpisService";
import { db } from "../../Config/firebase";
import { collection, getDocs, addDoc } from "firebase/firestore";
import { aplicarTenantAtual, consultaTenantAtual } from "../../Utils/tenant";

/* =========================
   ESTADO INICIAL
========================= */
const initialState = {
  nome: "",
  codigo: "",
  descricao: "",
  escopo: "",
  tipo: "numerico",
  regra: {
    operador: ">=",
    valor: "",
  },
  periodicidadeCiclos: "",
  ativo: true,
  mostrarNoDashboard: false,


   tipoKPI: "PESQUISA",
  tipoFormulario: "GERAL",
  considerarSomenteNC: false,
};

export default function KPIFormModal({ open, onClose, kpiId, onSaved }) {
  const editando = Boolean(kpiId);

  const [form, setForm] = useState(initialState);
  const [escopos, setEscopos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(null);

  const [showNovoEscopo, setShowNovoEscopo] = useState(false);
  const [novoEscopo, setNovoEscopo] = useState("");
  const [salvandoEscopo, setSalvandoEscopo] = useState(false);

  async function carregarEscopos() {
    const snap = await getDocs(consultaTenantAtual(collection(db, "kpi_escopos")));
    setEscopos(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  }

  async function carregarKPI() {
    if (!kpiId) {
      setForm(initialState);
      return;
    }

    const data = await getKPI(kpiId);

    setForm({
      nome: data.nome || "",
      codigo: data.codigo || "",
      descricao: data.descricao || "",
      escopo: data.escopo || "",
      tipo: data.tipo || "numerico",
      regra: data.regra || { operador: ">=", valor: "" },
      periodicidadeCiclos: data.periodicidadeCiclos || "",
            ativo: data.ativo ?? true,
      tipoKPI: data.tipoKPI || "PESQUISA",
      tipoFormulario: data.tipoFormulario || "GERAL",
      considerarSomenteNC: data.considerarSomenteNC || false,
      mostrarNoDashboard: data.mostrarNoDashboard ?? false,

    });
  }

  useEffect(() => {
    if (open) {
      carregarEscopos();
      carregarKPI();
    }
  }, [open, kpiId]);

  function onChange(e) {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  }

  function onChangeTipo(e) {
    const tipo = e.target.value;
    setForm(prev => ({
      ...prev,
      tipo,
      regra:
        tipo === "booleano"
          ? { valor: "true" }
          : { operador: ">=", valor: "" },
    }));
  }

  function onChangeRegra(e) {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      regra: {
        ...prev.regra,
        [name]: value,
      },
    }));
  }

  async function salvar(e) {
    e.preventDefault();
    setErro(null);

    if (
      !form.nome ||
      !form.codigo ||
      !form.escopo ||
      (form.tipoKPI === "PESQUISA" && !form.periodicidadeCiclos) ||
      (form.tipo !== "booleano" &&
        form.tipoKPI === "PESQUISA" &&
        !form.regra.valor)
    ) {
      setErro("Preencha os campos obrigatórios");
      return;
    }

    try {
      setLoading(true);
      editando
        ? await atualizarKPI(kpiId, form)
        : await criarKPI(form);

      onSaved();
      onClose();
      setForm(initialState);
    } catch {
      setErro("Erro ao salvar KPI");
    } finally {
      setLoading(false);
    }
  }

  async function salvarNovoEscopo() {
    if (!novoEscopo.trim()) return;

    try {
      setSalvandoEscopo(true);

      const codigo = novoEscopo
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "_")
        .toLowerCase();

      await addDoc(collection(db, "kpi_escopos"), aplicarTenantAtual({
        nome: novoEscopo,
        codigo,
        ativo: true,
        criadoEm: new Date(),
      }));

      setNovoEscopo("");
      setShowNovoEscopo(false);
      await carregarEscopos();
      setForm(prev => ({ ...prev, escopo: codigo }));
    } finally {
      setSalvandoEscopo(false);
    }
  }

  if (!open) return null;

  return (
    <>
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
        style={{ background: "rgba(0,0,0,.5)", zIndex: 1050 }}
      >
        <div
  className="bg-white p-4 rounded"
  style={{
    width: 600,
    maxHeight: "85vh",
    overflowY: "auto"
  }}
>

          <h5 className="mb-3">
            {editando ? "Editar KPI" : "Novo KPI"}
          </h5>

          {erro && <div className="alert alert-danger">{erro}</div>}

          <form onSubmit={salvar}>
            <input className="form-control mb-2" name="nome" placeholder="Nome do KPI" value={form.nome} onChange={onChange} />
            <input className="form-control mb-2" name="codigo" placeholder="Código (ex: RQ_1_2)" value={form.codigo} onChange={onChange} disabled={editando} />
            <textarea className="form-control mb-2" name="descricao" placeholder="Descrição do KPI" value={form.descricao} onChange={onChange} />

            <select
                        className="form-control mb-2"
                        value={form.tipoKPI}
                        onChange={e => {
                          const tipoKPI = e.target.value;
                          setForm(prev => ({
                            ...prev,
                            tipoKPI,
                            tipoFormulario: tipoKPI === "EVENTO" ? "GERAL" : prev.tipoFormulario,
                            escopo: tipoKPI === "EVENTO" ? "interno" : prev.escopo,
                            periodicidadeCiclos:
                              tipoKPI === "EVENTO" ? "" : prev.periodicidadeCiclos
                          }));
                        }}
                      >
                        <option value="PESQUISA">Tipo de KPI: Pesquisa</option>
                        <option value="EVENTO">Tipo de KPI: Evento / Registro</option>
                      </select>
{form.tipoKPI === "PESQUISA" && (
  <select
    className="form-control mb-2"
    name="tipoFormulario"
    value={form.tipoFormulario || "GERAL"}
    onChange={onChange}
  >
    <option value="GERAL">Tipo de formulário: Geral</option>
    <option value="PSICOSSOCIAL">Tipo de formulário: Psicossocial</option>
  </select>
)}

              {/* ===== ESCOPO DO KPI ===== */}
                  <div className="mb-2">
                              <label className="form-label">Escopo do KPI</label>

                              <div className="d-flex gap-2">
                                <select
                                  className="form-control"
                                  name="escopo"
                                  value={form.escopo}
                                  onChange={onChange}
                                  disabled={form.tipoKPI === "EVENTO"}
                                >
                                  <option value="">Selecione o escopo</option>

                                  {escopos
                                    .filter(e => e.ativo)
                                    .map(e => (
                                      <option key={e.id} value={e.codigo}>
                                        {e.nome}
                                      </option>
                                    ))}
                                </select>

                                <button
                                  type="button"
                                  className="btn btn-outline-secondary"
                                  title="Criar novo escopo"
                                  onClick={() => setShowNovoEscopo(true)}
                                  disabled={form.tipoKPI === "EVENTO"}
                                >
                                  +
                                </button>
                              </div>
                        

                    {form.tipoKPI === "EVENTO" && (
                      <small className="text-muted">
                        KPIs do tipo Evento pertencem ao escopo SGQ
                      </small>
                    )}
                  </div>

                  {showNovoEscopo && (
                      <div className="border rounded p-3 mb-3 bg-light">
                        <label className="form-label">Novo escopo</label>

                        <div className="d-flex gap-2">
                          <input
                            className="form-control"
                            placeholder="Ex: Cliente e Colaborador"
                            value={novoEscopo}
                            onChange={e => setNovoEscopo(e.target.value)}
                          />

                          <button
                            type="button"
                            className="btn btn-success"
                            disabled={salvandoEscopo}
                            onClick={salvarNovoEscopo}
                          >
                            Salvar
                          </button>

                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => setShowNovoEscopo(false)}
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    )}

                    {/* ===== REGRA / META DO KPI ===== */}
{form.tipoKPI === "PESQUISA" && form.tipo !== "booleano" && (
  <div className="mb-2">
    <label className="form-label">Meta esperada</label>

    <div className="d-flex gap-2">
      <select
        className="form-control"
        style={{ maxWidth: 120 }}
        value={form.regra.operador}
        onChange={e =>
          setForm(prev => ({
            ...prev,
            regra: {
              ...prev.regra,
              operador: e.target.value
            }
          }))
        }
      >
        <option value=">=">&ge;</option>
        <option value=">">&gt;</option>
        <option value="<=">&le;</option>
        <option value="<">&lt;</option>
      </select>

      <input
        type="number"
        className="form-control"
        placeholder="Ex: 85"
        value={form.regra.valor}
        onChange={e =>
          setForm(prev => ({
            ...prev,
            regra: {
              ...prev.regra,
              valor: e.target.value
            }
          }))
        }
      />
    </div>

    <small className="text-muted">
      Exemplo: ≥ 85% indica desempenho dentro do esperado
    </small>
  </div>
)}


            {form.tipoKPI === "EVENTO" && (
              <div className="form-check mb-3">
                <input type="checkbox" className="form-check-input" checked={form.considerarSomenteNC}
                  onChange={e => setForm(prev => ({ ...prev, considerarSomenteNC: e.target.checked }))} />
                <label className="form-check-label">
                  Considerar somente Não Conformidades (NC)
                </label>
              </div>
            )}

            <select className="form-control mb-2" value={form.tipo} onChange={onChangeTipo}>
              <option value="numerico">Numérico</option>
              <option value="percentual">Percentual</option>
              <option value="booleano">Booleano</option>
              <option value="texto">Texto</option>
            </select>

            {form.tipoKPI === "PESQUISA" && (
              <select className="form-control mb-2" name="periodicidadeCiclos" value={form.periodicidadeCiclos} onChange={onChange}>
                <option value="">Periodicidade</option>
                <option value="1">Anual</option>
                <option value="2">Semestral</option>
                <option value="4">Trimestral</option>
                <option value="12">Mensal</option>
              </select>
            )}

            <div className="form-check mb-3">
              <input type="checkbox" className="form-check-input" name="ativo" checked={form.ativo} onChange={onChange} />
              <label className="form-check-label">Ativo</label>
            </div>      


            <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="mostrarNoDashboard"
                  checked={form.mostrarNoDashboard}
                  onChange={onChange}
                />
                <label className="form-check-label">
                  Mostrar este KPI no Dashboard
                </label>
              </div>




            <div className="d-flex justify-content-end gap-2">
              <button type="button" className="btn btn-outline-secondary" onClick={onClose}>Cancelar</button>
              <button className="btn btn-success" disabled={loading}>
                {loading ? "Salvando..." : "Salvar"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
